import defaultState from './defaultState'

const getState = state => state.jobapplication || defaultState

export const getSubmitting = state => getState(state).submitting
export const getSubmitted = state => getState(state).submitted
export const getVisible = state => getState(state).visible
export const getErrors = state => getState(state).errors
export const getRate = state => getState(state).rate
export const getType = state => getState(state).type
export const getInfo = state => getState(state).info
export const getAttachmentsToReuse = state => getState(state).attachmentsToReuse.attachments
export const getAttachmentsToReuseFromDraft = state => getState(state).attachmentsToReuse.draft
export const reusingAttachmentsAllowed = state => getAttachmentsToReuse(state)?.length > 0
export const getExcludeIds = state => getState(state).excludeIds
export const getLoopValue = state => getState(state).excludeIds.length
export const getJobLoading = state => getState(state).jobLoading
export const getJobLoadingErrors = state => getState(state).jobLoadingErrors
export const getJobForApplication = state => getState(state).jobForApplication
export const getDisplayJobForApplicationForm = state => getState(state).displayJobForApplicationForm
export const getLoadingJobForApplication = state => getSubmitting(state) || getJobLoading(state)
export const getShouldLoadJobForApplication = state => !getJobForApplication(state)?.id && !getExcludeIds(state).length
export const getEnableJobForApplication = state => getState(state).enableJobForApplication
